import Vue from 'vue'
import Router from 'vue-router'

const Main = () => import('./modules/Layout/index.vue');



import loginRoutes from '@/modules/Authentication/router'

import homeRoutes from '@/modules/Home/router'

// import globalRoutes from '@/modules/Global/router'
// import publicRoutes from '@/modules/Public/router'

import userRoutes from '@/modules/User/router.js'
import profileRoutes from '@/modules/Profile/router.js'
import chatRoutes from '@/modules/Chat/router.js'
const PageNotFound = () => import('./views/PageNotFound.vue');
const VerifyEmail = () => import('@/modules/Authentication/components/VerifyEmail.vue');

Vue.use(Router);

let mainRoutes = []
mainRoutes = mainRoutes.concat(homeRoutes)
mainRoutes = mainRoutes.concat(userRoutes)
mainRoutes = mainRoutes.concat(profileRoutes)
mainRoutes = mainRoutes.concat(chatRoutes)


let routes = [{
  path: '/',
  component: Main,
  children: mainRoutes,
},
{
  path: '*',
  name: 'pagenotfound',
  component: PageNotFound,
},
{
  path: '/verify',
  name: 'verify-email',
  component: VerifyEmail,
  meta: { public: true },
},
]


// routes = routes.concat(publicRoutes)
// routes = routes.concat(globalRoutes)
routes = routes.concat(loginRoutes)


const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
    return {
      x: 0,
      y: 0
    }
  },
})


// router.beforeEach((to, from, next) => {
//   const loginToken = localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`);

//   if (loginToken) {
//     // logged in, continue
//     next();
//   } else {
//     // not logged in
//     if (to.meta.public || to.name === 'authentication-login') {
//       // allow access to public routes or login
//       next();
//     } else {
//       // redirect to login with intended route
//       next({
//         name: 'authentication-login',
//         query: { redirect: to.fullPath }
//       });
//     }
//   }
// });

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`);
  
  // If public route or login page, skip
  if (to.meta.public || to.name === "authentication-login") {
    next();
    return;
  }

  if (!token) {
    return next({
      name: "authentication-login",
      query: { redirect: to.fullPath },
    });
  }

  // Simple expiration check (optional, if your JWT encodes exp)
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (payload.exp && Date.now() >= payload.exp * 1000) {
      localStorage.removeItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`);
      return next({ name: "authentication-login" });
    }
  } catch (err) {
    console.warn("Invalid token format");
    localStorage.removeItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`);
    return next({ name: "authentication-login" });
  }

  next();
});

export default router